import { render } from "./RegistrarBoletoPage.vue?vue&type=template&id=9ffe84cc&scoped=true"
import script from "./RegistrarBoletoPage.vue?vue&type=script&lang=js"
export * from "./RegistrarBoletoPage.vue?vue&type=script&lang=js"

import "./RegistrarBoletoPage.vue?vue&type=style&index=0&id=9ffe84cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ffe84cc"]])

export default __exports__